import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-jitb',
  templateUrl: './jitb.component.html',
  styleUrls: ['./jitb.component.scss']
})
export class JitbComponent implements OnInit {

  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['jitb'];
  }

}
